/**
 * iter-108 — Tenant-wide schedules pause helper.
 *
 * Persists the "schedules_paused_until" ISO timestamp in localStorage so
 * every auto-refresh ticker (DashboardScheduleControl) can cheaply check
 * before dispatching a `dashboard:refresh` event without an API roundtrip
 * on every tick.
 *
 * The Schedules page is the source of truth — its load() / pauseAll() /
 * resumeAll() update this store, and a window event fans the change out
 * to other tabs/components that read it.
 */
const KEY = "analyzio_schedules_paused_until";
const EVT = "schedules:pause-changed";

export function getPauseUntil() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const t = new Date(raw);
        if (isNaN(t.getTime()) || t.getTime() <= Date.now()) {
            localStorage.removeItem(KEY);
            return null;
        }
        return raw;
    } catch (_e) {
        return null;
    }
}

export function isPaused() {
    return !!getPauseUntil();
}

export function setPauseUntil(iso) {
    try {
        if (iso) localStorage.setItem(KEY, iso);
        else localStorage.removeItem(KEY);
        window.dispatchEvent(new CustomEvent(EVT, { detail: { until: iso || null } }));
    } catch (_e) {}
}

export const PAUSE_EVENT = EVT;
